import {InputToggleProps} from "app/Interface/Component/FormInput"
import cls from "classnames"
import React from "react"
import Toggle from "react-toggle"
import Check from "static/icons/check_black_24dp.svg"
import Clear from "static/icons/clear_black_24dp.svg"

function InputToggle({id, value, onChange, check, unchecked, disabled}: InputToggleProps) {
  return (
    <Toggle
      id={`toggle-${id}`}
      checked={value}
      onChange={() => onChange(!value)}
      icons={{checked: check ?? <Check/>, unchecked: unchecked ?? <Clear/>}}
      className={cls('form-control', id)}
      disabled={disabled}
    />
  )
}

export default InputToggle
